import { Injectable } from '@angular/core';
import * as _ from "lodash";
import { DisplayOptions } from './display-options';

@Injectable({
  providedIn: 'root'
})
export class DisplayOptionsService {

  private displayOptions: any;

  public getOptions(): DisplayOptions {
    if (!this.displayOptions) {
      this.displayOptions = {};
    }

    return this.displayOptions;
  }

  public initialize(displayOptions: DisplayOptions): void {
    if (!this.displayOptions) {
      this.displayOptions = {};
    }

    _.extend(this.displayOptions, displayOptions);
  }
}
